export interface UserModel {
  userId: string;
  email: string;
  firstName: string;
  middleName: string;
  lastName: string;
  userType: string;
  profileImage: string;
  defaultCompanyId: number;
  profileComplete: boolean;
  admin: boolean;
  incompleteSections: number[];
}

export class User {
  firstName: string;
  constructor(user: any) {
    Object.keys(user).forEach((key) => {
      this[key] = user[key];
    });
  }
}
